import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import { setCookie } from '@/shared/lib/formatter'

export function useUpdateCurrentPath(): void {
  const location = useLocation()
  const prevPathnameRef = useRef(location.pathname)
  const prevSearchRef = useRef(location.search)

  useEffect(() => {
    const pathnameChanged = prevPathnameRef.current !== location.pathname
    const searchChanged = prevSearchRef.current !== location.search

    if (pathnameChanged || searchChanged) {
      const currentPath = location.pathname + location.search
      setCookie('currentPath', currentPath)
      prevPathnameRef.current = location.pathname
      prevSearchRef.current = location.search
    }
  }, [location.pathname, location.search])
}

export default useUpdateCurrentPath
